

<div class="innerpage no-scroll" style="background:#e5e5e5; padding-top:23px;">
  <div class="container">
  <section class="itinerarySction" *ngFor="let _ of [].constructor(6)">
    <ng-container>
      <div class="earthloader loaderLoding">
        <img src="../../../../../assets/belairtrip_assets/svg_icon/belairloader.gif" alt="" class="img-fluid">
        <div class="content_loader">
          <p>Hold on, searching for the best offers and flights for you</p>
        </div>
      </div>
      <div class="loader-holder">
      <div class="w-100">
          <mat-card>
              <ng-container>
                <div class="flightInformation">
                  <div class="flightInfo web_view">
                    <p class="img"  class="img-fluid"></p>
                    <div class="carrierInfo">
                      <p class="carriername"></p>
                      <p class="carrierNumber"><span
                          
                          class="stopageVia">,&nbsp;</span></p>
                    </div>
                  </div>
                  <div class="flightTimeInfo">
                    <div class="middleFirst">
                          <p></p>
                          <span></span>
                    </div>
                    <div class="middleSecond">
                      <div class="timeDuration">
                        <p class="fp"></p>
                        <div class="distanceLine">
                          <span></span>
                          <span  class="stopagePoint"><span></span></span>
                        </div>
                        <p class="lp"></p>
                      </div>
                    </div>
                    <div class="middleThird">
                        <p></p>
                       <span></span>
                    </div>
                  </div>
                  <div class="flightTotlalPrice">
                    <p></p>
                  </div>
                </div>
              </ng-container>
              <div class="itineraryDetail">
                  <div class="itineraryInfo">
                    <div class="extraInfo">
                      <p></p>
                    </div>
                  </div>
                 <div class="extradiv">
                  <div class="left-option">
                      <img src=""/>
                      <p></p>
                  </div>
                  <div class="right-option">
                      <img src=""/>
                      <p></p>
                  </div>
                 </div>
                </div>
            </mat-card>
      </div>
  </div>
    </ng-container>
  </section>

  <!-- <div class="blankdiv">

  </div> -->
</div>
</div>
 
  
